import { useState, type ReactNode } from "react";
import clsx from "clsx";

interface CollapsibleSectionProps {
  title: string;
  hint?: string;
  defaultOpen?: boolean;
  children: ReactNode;
  className?: string;
}

export function CollapsibleSection({
  title,
  hint,
  defaultOpen = false,
  children,
  className,
}: CollapsibleSectionProps) {
  const [open, setOpen] = useState(defaultOpen);
  return (
    <section className={clsx("card overflow-hidden", className)}>
      <button
        type="button"
        onClick={() => setOpen((v) => !v)}
        className="w-full flex items-center justify-between gap-3 px-3 h-11 border-b border-border1"
        aria-expanded={open}
      >
        <span className="flex items-baseline gap-2 min-w-0">
          <span className="text-[11px] font-semibold tracking-[0.18em] uppercase text-text truncate">
            {title}
          </span>
          {hint && (
            <span className="text-[10.5px] text-muted truncate">{hint}</span>
          )}
        </span>
        <Chevron open={open} />
      </button>
      {open && <div>{children}</div>}
    </section>
  );
}

function Chevron({ open }: { open: boolean }) {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      aria-hidden="true"
      className={clsx("text-muted transition-transform", open && "rotate-180")}
    >
      <path
        d="M3 5l4 4 4-4"
        stroke="currentColor"
        strokeWidth="1.6"
        fill="none"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
